import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ISchoolContactServiceResponse } from "../../api/PartnerPortalGatewayApi";

interface ServiceState {
  selectedService: ISchoolContactServiceResponse | null;
  availableServices: ISchoolContactServiceResponse[];
  isLoading: boolean;
}

const initialState: ServiceState = {
  selectedService: null,
  availableServices: [],
  isLoading: false,
};

export const serviceSlice = createSlice({
  name: "service",
  initialState,
  reducers: {
    setSelectedService: (state, action: PayloadAction<ISchoolContactServiceResponse | null>) => {
      state.selectedService = action.payload;
    },
    setAvailableServices: (state, action: PayloadAction<ISchoolContactServiceResponse[]>) => {
      state.availableServices = action.payload;
      // If there's only one service, auto-select it
      if (action.payload.length === 1) {
        state.selectedService = action.payload[0];
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    clearServiceData: (state) => {
      state.selectedService = null;
      state.availableServices = [];
      state.isLoading = false;
    },
  },
});

export const { setSelectedService, setAvailableServices, setLoading, clearServiceData } = serviceSlice.actions;
